import React, {useEffect} from "react";
import logoIcon from "../assets/images/logoColour.png";
import githubLogo from "../assets/images/github-mark-white.png";
import {useSearchParams} from "react-router-dom";
import axios from "../utility/customAxios";
import {usePreserveQueryParamsNavigate} from "../components/ui/lib/utils";

function GithubRedirect() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = usePreserveQueryParamsNavigate();

    useEffect(() => {
        const installationId = searchParams.get("installation_id");
        if (!installationId) {
            navigate("/settings?tab=integrations");
            return
        } else {
            const githubDetailsJson = {
                installationId: installationId,
            }
            // This will return the jwt and we can use it to get the installation access token.
            axios.post("/api/v1/integrations", {
                type: "githubV2",
                integrationCredentialsJson: JSON.stringify(githubDetailsJson),
            }).then((response) => {
                if (response.status === 200) {
                    // Wait for 3 seconds before redirecting
                    setTimeout(() => {
                        // Redirect to the settings page with the query params
                        navigate("/settings?tab=integrations");
                    }, 4000);
                } else {
                    // TODO: Show an error message if the response is not 200
                    console.error("Failed to connect GitHub integration");
                }
            }).catch((e) => {
                console.error(e);
            })
        }
        const code = searchParams.get("code");
    }, [searchParams]);

    return (searchParams.get("installation_id") && <div
        className="container relative h-screen flex items-center justify-center lg:max-w-none lg:px-0 lg:grid-cols-2 bg-background">
        <div
            className="p-32  rounded border border-border flex-col justify-center items-center gap-16 inline-flex">
            <div className="mx-auto flex w-full flex-col justify-center space-y-6">
                <div className="flex space-y-2 text-center justify-center">
                    <div className={"flex flex-none justify-center"}>
                        <img src={logoIcon} alt="Metoro" className="w-28 h-28"/>
                    </div>
                    <div className={"flex items-center"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="128" height="64" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                             className={"lucide lucide-chevrons-left-right-ellipsis text-border animate-pulse"}>
                            <path d="m18 8 4 4-4 4" className="origin-center animate-[slideRight_1.5s_ease-in-out_infinite]"/>
                            <path d="m6 8-4 4 4 4" className="origin-center animate-[slideLeft_1.5s_ease-in-out_infinite]"/>
                            <path d="M8 12h.01" className="animate-pulse" style={{animationDelay: '0ms'}}/>
                            <path d="M12 12h.01" className="animate-pulse" style={{animationDelay: '250ms'}}/>
                            <path d="M16 12h.01" className="animate-pulse" style={{animationDelay: '500ms'}}/>
                        </svg>
                    </div>
                    <div className={"flex flex-col items-center justify-center"}>
                        <img src={githubLogo} alt={"GitHub"} className={"w-24 h-24 mx-4"}/>

                    </div>
                </div>
                <div className={"text-textmedium text-3xl font-semibold text-center flex items-center justify-center"}>
                    <span className="animate-[fadeInUp_1s_ease-out]">Connecting Metoro and GitHub</span>
                    <span className="inline-flex ml-1">
                        <span className="animate-pulse" style={{animationDelay: '0ms'}}>.</span>
                        <span className="animate-pulse" style={{animationDelay: '200ms'}}>.</span>
                        <span className="animate-pulse" style={{animationDelay: '400ms'}}>.</span>
                    </span>
                </div>
            </div>
        </div>
    </div>)
}

export default GithubRedirect;
export {GithubRedirect};